import { useState } from "react"
import { Button, Card, Col, Container, Form, Row } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import DateInput from "../../../components/InputWrapper/DateInput"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import dateUtil from "../../../ts/util/dateUtil"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import Spinner from "../../../components/Spinner"
import { AppDispatch } from "../../.."
import {
  clearAlert,
  setWarningAlerts,
  setAlerts,
} from "../../../globalStore/alertStore"

import NinusiHokokusyoService from "../../../service/billing/ninusiHokokusyo/ninusiHokokusyoService"
import { TNinusiHokokusyoPrintYamadaReq } from "../../../service/billing/ninusiHokokusyo/TNinusiHokokusyo"

const NinusiHokokusyoYamada = () => {
  const { eigyobiStr: 当営業日 } = useSelector((state: RootState) => state.date)
  const 月初日 = dateUtil.format(
    dateUtil.addDay(当営業日, 1 - parseInt(dateUtil.format(当営業日, "DD"))),
    "YYYY/MM/DD"
  )

  //#region [baseState]
  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  //#endregion

  //#region [comboboxState]
  // 抽出対象期間
  const [積卸日From, set積卸日From] = useState<string | null | undefined>(
    月初日
  )
  const [積卸日To, set積卸日To] = useState<string | null | undefined>(当営業日)

  //#endregion

  //#region [method]
  /**
   * 山田産業報告書印刷処理
   */
  const printYamadaHokokusyo = async () => {
    const 抽出開始日 = 積卸日From
      ? dateUtil.format(積卸日From, "YYYY/MM/DD")
      : ""
    const 抽出終了日 = 積卸日To ? dateUtil.format(積卸日To, "YYYY/MM/DD") : ""

    if (抽出開始日 > 抽出終了日) {
      dispatch(setWarningAlerts(["日付指定が「開始日付 ＞ 終了日付」となっています"]))
      return
    }

    const printCondition: TNinusiHokokusyoPrintYamadaReq = {
      抽出条件_積卸日From: 抽出開始日,
      抽出条件_積卸日To: 抽出終了日,
    }

    setIsSearching(true) // 検索中状態に遷移

    try {
      const service = new NinusiHokokusyoService({ responseType: "blob" })
      const res = await service.printHokokusyoYamada(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">山田産業報告書印刷</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 印刷条件カード */}
          <Card className="w-90rem">
            <Card.Header>印刷条件</Card.Header>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body id="collapse-search-card-body">
              <Form>
                <Container fluid className="contents-search-main">
                  <Row>
                    <Col>
                      <ul className="list-cmn  d-flex">
                        <li>
                          <ul className="list-cmn list-padding ">
                            <li className="list-cmn d-flex">
                              <div className="w-8-5rem">
                                <DateInput
                                  id="積卸日From"
                                  placeholder="積卸日From"
                                  isRequired={true}
                                  value={積卸日From}
                                  defaultValue={月初日}
                                  setValue={(v) => {
                                    set積卸日From(v)
                                  }}></DateInput>
                              </div>
                              <div style={{ width: "2rem", padding: "0.5rem" }}>
                                ～
                              </div>
                              <div className="w-8-5rem">
                                <DateInput
                                  id="積卸日To"
                                  placeholder="積卸日To"
                                  value={積卸日To}
                                  isRequired={true}
                                  defaultValue={当営業日}
                                  setValue={(v) => {
                                    set積卸日To(v)
                                  }}></DateInput>
                              </div>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <ul className="list-cmn  d-flex">
                        <li>
                          <ul className="list-cmn list-padding ">
                            <li className="list-cmn d-flex">
                              <div className="w-8rem me-3">
                                <Button
                                  className="btn-done"
                                  onClick={(e) => {
                                    dispatch(clearAlert())
                                    e.preventDefault()
                                    e.stopPropagation()
                                    printYamadaHokokusyo()
                                  }}>
                                  <FontAwesomeIcon icon={faFileAlt} />
                                  印刷
                                </Button>
                              </div>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default NinusiHokokusyoYamada
